import styled from "styled-components"

export const TotalsComparison = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background: ${(p) => p.theme.colors.background};
  border-radius: 0.5rem;
  border: 1px solid ${(p) => p.theme.colors.borderLight};
`

export const TotalsHeader = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 1rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${(p) => p.theme.colors.borderLight};
  margin-bottom: 0.5rem;
  font-weight: 700;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDark};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const TotalsRow = styled.div<{ $highlight?: boolean }>`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem 0;
  font-weight: ${(p) => (p.$highlight ? "700" : "400")};
  font-size: ${(p) => (p.$highlight ? "1.2rem" : "1.1rem")};

  ${(p) =>
    p.$highlight &&
    `
    border-top: 1px solid ${p.theme.colors.borderLight};
    margin-top: 0.5rem;
    padding-top: 1rem;
  `}
`

export const TotalsLabel = styled.span`
  color: ${(p) => p.theme.colors.greyDark};
`

export const TotalsCell = styled.span<{ $type?: "before" | "after" | "diff" }>`
  text-align: right;
  color: ${(p) => {
    if (p.$type === "before") return p.theme.colors.greyDark
    if (p.$type === "diff") return p.theme.colors.black
    return "inherit"
  }};
`

// Order Lines Table
export const OrderLinesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  font-size: 1.1rem;
`

export const TableHeader = styled.thead`
  background: ${(p) => p.theme.colors.background};
  border-bottom: 2px solid ${(p) => p.theme.colors.borderLight};

  th {
    padding: 0.8rem 0.5rem;
    text-align: left;
    font-weight: 700;
    font-size: 1rem;
    color: ${(p) => p.theme.colors.greyDark};
    text-transform: uppercase;
    letter-spacing: 0.05em;

    &:not(:first-child) {
      text-align: right;
    }
  }
`

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid ${(p) => p.theme.colors.borderLight};

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: ${(p) => p.theme.colors.backgroundHover};
    }
  }

  td {
    padding: 0.8rem 0.5rem;
    vertical-align: middle;

    &:not(:first-child):not(:nth-child(2)) {
      text-align: right;
    }
  }
`

export const TypeBadge = styled.span<{ $type: string }>`
  display: inline-block;
  font-size: 0.9rem;
  padding: 0.25rem 0.6rem;
  border-radius: 0.3rem;
  font-weight: 600;
  min-width: 70px;
  text-align: center;
  background: ${(p) => {
    switch (p.$type) {
      case "CREATE":
        return p.theme.colors.success.background
      case "DELETE":
        return p.theme.colors.error.background
      case "UPDATE":
        return p.theme.colors.blue
      default:
        return p.theme.colors.background
    }
  }};
  color: ${(p) => {
    switch (p.$type) {
      case "CREATE":
        return p.theme.colors.success.text
      case "DELETE":
        return p.theme.colors.error.text
      case "UPDATE":
        return p.theme.colors.white
      default:
        return p.theme.colors.greyDark
    }
  }};
`
